var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 7,
    fill: "#F4F2FE",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5298 13.2492C20.3247 13.404 21.0553 13.792 21.628 14.3636C22.2007 14.9352 22.5895 15.6644 22.7446 16.4578M19.5298 10C21.1814 10.1831 22.7214 10.9213 23.8972 12.0933C25.0729 13.2653 25.8144 14.8015 26 16.4497M25.1861 22.9319V25.3688C25.1871 25.595 25.1406 25.819 25.0498 26.0262C24.959 26.2335 24.8258 26.4196 24.6588 26.5725C24.4918 26.7255 24.2946 26.8419 24.0799 26.9144C23.8652 26.9869 23.6377 27.0138 23.4119 26.9934C20.9075 26.7218 18.5019 25.8677 16.3883 24.4996C14.4219 23.2525 12.7547 21.5885 11.5052 19.6258C10.1297 17.5067 9.27375 15.094 9.00661 12.5831C8.98627 12.3585 9.01301 12.1321 9.08514 11.9184C9.15727 11.7046 9.2732 11.5082 9.42555 11.3416C9.5779 11.175 9.76334 11.042 9.97005 10.9508C10.1768 10.8597 10.4002 10.8125 10.6262 10.8123H13.0678C13.4627 10.8084 13.8456 10.948 14.1451 11.2051C14.4446 11.4621 14.6402 11.8191 14.6955 12.2095C14.7985 12.9893 14.9897 13.7551 15.2652 14.492C15.3747 14.7828 15.3984 15.0988 15.3335 15.4025C15.2686 15.7063 15.1178 15.9851 14.899 16.206L13.8653 17.2376C15.0239 19.2713 16.711 20.9551 18.7485 22.1115L19.7821 21.0798C20.0034 20.8614 20.2828 20.7109 20.5871 20.6461C20.8915 20.5814 21.2081 20.605 21.4994 20.7143C22.2377 20.9893 23.0049 21.1801 23.7863 21.2829C24.1816 21.3386 24.5427 21.5373 24.8008 21.8414C25.0589 22.1454 25.196 22.5335 25.1861 22.9319Z",
    stroke: "url(#paint0_linear_81_836)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_836",
    x1: 22.5,
    y1: 10,
    x2: 9,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A92FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.21ebde194722208e23898d009c3d776c.svg";
export { ForwardRef as ReactComponent };